export function Separator() {
    return (
        <div className="separator">
            <img src="https://assets.website-files.com/62b46e994f1dca9e9be49474/62b46e994f1dca6642e4952e_gradient-border-footer.svg" alt="separator" />
        </div>
    )
}